import { defineMessages } from '@formatjs/intl';

import { Review } from '@/components/homepageRefresh/homepage/Testimonials/types';

export const messages = defineMessages({
	reviewsHeading: {
		id: 'subpage.stress.testimonials.reviewsHeading2',
		defaultMessage: 'Join the millions using Calm to manage anxiety, soothe stress and feel better.',
		description: 'Heading for section showing users that love Calm',
	},
	review1Quote: {
		id: 'subpage.stress.testimonials.review1quote',
		defaultMessage:
			"I woke up super panicked and used Calm for about 15 minutes. Three days in and it's made a difference!",
		description: 'Quote from a Calm app review',
	},
	review1Author: {
		id: 'subpage.stress.testimonials.review1Author',
		defaultMessage: 'Vivian from San Gabriel',
		description: 'Author of Calm app review',
	},
	review2Quote: {
		id: 'subpage.stress.testimonials.review2quote',
		defaultMessage:
			"Calm is a life-changing app. Now I've been meditating for 3 years and it's been able to really reduce the anxiety that was creating a lot of issues in my life.",
		description: 'Quote from a Calm app review',
	},
	review2Author: {
		id: 'subpage.stress.testimonials.review2Author',
		defaultMessage: 'Alex from Orlando',
		description: 'Author of Calm app review',
	},
	review3Quote: {
		id: 'subpage.stress.testimonials.review3quote',
		defaultMessage: 'Following each session, I feel less stressed, and that feeling carries into my day.',
		description: 'Quote from a Calm app review',
	},
	review3Author: {
		id: 'subpage.stress.testimonials.review3Author',
		defaultMessage: 'Hamilton from St. Louis',
		description: 'Author of Calm app review',
	},
	review4Quote: {
		id: 'subpage.stress.testimonials.review4quote',
		defaultMessage:
			'I never realized how much I needed this until I committed to 10 minutes a day and realized how much more easily I could deal with stress.',
		description: 'Quote from a Calm app review',
	},
	review4Author: {
		id: 'subpage.stress.testimonials.review4Author',
		defaultMessage: 'Kristie from Austin',
		description: 'Author of Calm app review',
	},
	review5Quote: {
		id: 'subpage.stress.testimonials.review5quote',
		defaultMessage:
			'I get a lot of anxiety attacks. I never knew how to cope with them, but this app has really helped me a lot.',
		description: 'Quote from a Calm app review',
	},
	review5Author: {
		id: 'subpage.stress.testimonials.review5Author',
		defaultMessage: 'Teri from Long Beach',
		description: 'Author of Calm app review',
	},
	review6Quote: {
		id: 'subpage.stress.testimonials.review6quote',
		defaultMessage:
			"I'm not sure how Tamara knows just what I need to hear in the daily meditations, but it almost always hits me in just the right way.",
		description: 'Quote from a Calm app review',
	},
	review6Author: {
		id: 'subpage.stress.testimonials.review6Author',
		defaultMessage: 'Mikey from Costa Mesa',
		description: 'Author of Calm app review',
	},
});

export const reviews: Review[] = [
	{
		quote: messages.review1Quote,
		author: messages.review1Author,
	},
	{
		quote: messages.review2Quote,
		author: messages.review2Author,
	},
	{
		quote: messages.review3Quote,
		author: messages.review3Author,
	},
	{
		quote: messages.review4Quote,
		author: messages.review4Author,
	},
	{
		quote: messages.review5Quote,
		author: messages.review5Author,
	},
	{
		quote: messages.review6Quote,
		author: messages.review6Author,
	},
];
